<template lang="pug">
.giftcard-check-balance-container.m-b-40
  re-toast-alert.m-t-50(v-if="checkingErrorMessage" type="danger") {{ checkingErrorMessage }}

  .check-card.check-card-gift
    h3.check-card__caption Check gift card balance
    .check-card__col
      p.check-card__text Gift Card Number
      p.check-card__text Code
    .check-card__col
      input.check-card__inp.number(v-model="number" type="number" placeholder="XXXX XXXX XXXX XXXX")
      input.check-card__inp.code(v-model="cvv" type="password" placeholder="****" maxlength="4")
    .check-card__col
      a.check-card__link(href="" @click.prevent="$refs.whatIsNumberModal.show") What is this?
      a.check-card__link(href="" @click.prevent="$refs.forgot.show") Forgot Code?
  re-content-placeholder(name="check_card_balance_below_card_number_entry")
  .check-balance__button.m-b-20
    v-button.site_button.site_button_inverse(@click="check" :loading="isChecking" :disabled="$v.checkGroup.$invalid" no-default-class)
      span Check Gift Card Balance
  div
    p.check-balance__reload-text Would you like to
      router-link.check-balance__reload-link(:to="{ name: 'racewaybooking.gift-card' }")  purchase Gift Card?

  substrate(v-if="showBalanceModal" @close="showBalanceModal = false" inner-class="substrate__popup-change-pass-padd")
    p.substrate__popup-change-pas__caption.substrate__popup-change-pas__caption-mod Gift Card Balance
    p.price(v-if="giftcard") {{ giftcard.balance | currency }}
    div
      router-link(:to="{ name: 'racewaybooking.gift-card' }")
        button.site_button.substrate__popup-change-pass__more.substrate__button__full-w(type="button")
          span Purchase a gift card

  re-giftcard-forgot(ref="forgot")

  what-is-giftcard-number-modal(ref="whatIsNumberModal")

</template>

<script>
import axios from 'axios'
import {getQS} from '../../lib/utils'
const qs = getQS() || {}
const defaultNumber = qs.number
import { required } from 'vuelidate/lib/validators'

import { getFirstErrorMessage } from '~/lib/axios'

import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'
import GiftcardMixins from '../../components/_mixins/giftcard'

const EventBus = window.VueEventBus

export default {
  mixins: [
    ConfigMixin,
    PagesMixin,
    GiftcardMixins,
  ],

  data: () => ({
    number: defaultNumber,
    cvv: null,
    giftcard: null,
    recoveredEmail: null,

    isChecking: false,
    isRecovering: false,

    checkingErrorMessage: null,
    recoveringErrorMessage: null,

    showBalanceModal: false,
    showWhatIsNumberModal: false,
    showGiftcardCVVModal: false,
  }),

  validations: {
    number: {
      required,
    },
    cvv: {
      required,
    },
    checkGroup: [
      'number', 'cvv'
    ],
    recoverGroup: [
      'number',
    ],
  },

  methods: {

    async check() {
      try {
        const payload = {
          number: this.number,
          cvv: this.cvv,
        }
        this.isChecking = true
        const { data: { data: giftcard } }  = await axios.post(`${this.config.apiUri}/customer/giftcard/check`, payload)
        this.giftcard = giftcard
        this.showBalanceModal = true
        this.checkingErrorMessage = null

        EventBus.$emit('card.check-balance.success', giftcard)
      } catch (e) {
        this.checkingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isChecking = false
      }
    },
  },
}
</script>

<style lang="scss">
.giftcard-check-balance-container {
  .substrate__popup-change-pass input {
    border: 1px solid #BEBEBE;
    width: 100%;
    height: 50px;
  }

  @media screen and (max-width: 375px) {
    .check-card {
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
